import { Radio as AntdRadio } from 'antd'
import Button from 'components/Button'
import DragDiv from 'components/DragDiv/index.js'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import Radio from 'components/Form/RadioWithBorder'
import RichEditor from 'components/RichEditor/RoundRichText.js'
import {
  FlexWrap,
  FormItem,
  RedText,
  SecondaryHeading,
} from 'components/UIComponents/FormStyles'
import PlusIcon from 'components/icons/PlusIcon'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'

const RadioGroup = styled(AntdRadio.Group)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 36px;
  margin-top: 8px;

  .ant-radio-wrapper {
    white-space: break-spaces;
    overflow: hidden;
    align-items: center;
    text-overflow: ellipsis;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
  .ant-radio-inner {
    margin-top: -5px;
  }
`

const EvaluationForm = ({
  isEditRoleOnView = false,
  singleRoleData = {},
  addNewRound,
  updateRoundData,
  updateNewRound,
  roundData,
  setSortedItems,
  sortedItems,
  save,
  setSave,
  openDrawer,
  setRoundValues,
  roundValues,
  atsParam,
  candidateCall,
  setOpenDrawer,
  scheduleTrue,
  setScheduleTrue,
  isEditingForm,
  setIsEditingForm,
  setSaveEnable,
  rolesMetrics,
  getRoleMetrics,
  fetchRounds,
  isSubmitting,
  setIsSubmitting
}) => {
  const params = useParams()
  const [duplicateRoundName, setDuplicateRoundName] = useState(false)

  const [currentId, setCurrentId] = useState('')
  const [disableNameField, setDisableNameField] = useState(false)
  const [editText, setEditText] = useState(false)
  const [key, setKey] = useState(0)
  const [error,setError] = useState(true)
  const handleClear = () => {
    setKey(prevKey => prevKey + 1)
  }
  const handleEditDelete = (current, action, disableName = false) => {
    if (action == 'edit') {
      setDisableNameField(disableName)
      setIsEditingForm(true)
      setCurrentId(current?.name)
      setRoundValues({
        ...roundValues,
        roundNameError: '',
        interviewTypeError: '',
        assessmentTypeError: '',
        roundDescriptionError: '',
        roundName: current?.name,
        interviewType: current?.prePlacement === true ? '' : current?.type,
        assessmentType:
          current?.prePlacement === true
            ? ''
            : current?.assesmentType
            ? current?.assesmentType
            : '',
        faceToFaceType:
          current?.prePlacement === true
            ? ''
            : current?.faceToFaceType
            ? current?.faceToFaceType
            : '',
        roundDescription: current?.description,
        id: current?.id ?? '',
        prePlacement: current?.prePlacement ?? false,
      })
      setKey(prevKey => prevKey + 1)
      setEditText(true)
    }
    if (action == 'delete') {
      let newData = sortedItems?.filter(item => item?.name != current?.name)
      setSortedItems(newData)
      setSaveCall({ saveDetailSecond: true, saveDetailfirst: true })
    }
    if (action == 'cancel' || action == 'delete') {
      setIsEditingForm(false)
      setEditText(true)
      setKey(prevKey => prevKey + 1)
      setRoundValues({
        ...roundValues,
        roundName: '',
        roundNameError: '',
        interviewType: '',
        interviewTypeError: '',
        assessmentType: '',
        assessmentTypeError: '',
        roundDescription: '',
        faceToFaceTypeError: '',
        faceToFaceType: '',
        roundDescriptionError: '',
        id: '',
        prePlacement: false,
      })
      handleClear()
      setDisableNameField(false)
    }
  }
  const RadioOptions = [
    {
      id: 4,
      label: 'CV Screening',
      value: 'CV_SCREENING',
      disabled: isEditRoleOnView,
    },
    {
      id: 1,
      label: 'Assessment',
      value: 'ASSESMENT',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'Group Discussion',
      value: 'GROUP',
      disabled: isEditRoleOnView,
    },
    {
      id: 3,
      label: 'Interview',
      value: 'FACE_TO_FACE',
      disabled: isEditRoleOnView,
    },
    {
      id: 5,
      label: 'External Assessment',
      value: 'EXTERNAL_ASSESMENT',
      disabled: isEditRoleOnView,
    },
  ]
  const assessmentOptions = [
    {
      id: 1,
      label: 'Communication',
      value: 'COMUNICATION',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'Behavioural',
      value: 'BEHAVIOURAL',
      disabled: isEditRoleOnView,
    },
     {
      id: 3,
      label: 'Aptitude',
      value: 'APTITUDE',
      disabled: isEditRoleOnView,
    },
    {
      id: 4,
      label: 'Technical',
      value: 'TECHNICAL',
      disabled: isEditRoleOnView,
    },
 
  ]
  const externalAssessmentTypes = [
    { label: 'Test Gorilla', value: 'TEST_GORILA' },
    { label: 'ESkill', value: 'E_SKILL' },
  ]
  

  const faceToFaceOptions = [
    {
      id: 1,
      label: 'Business',
      value: 'BUSINESS',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'HR Round',
      value: 'HR_ROUND',
      disabled: isEditRoleOnView,
    },
  ]

  const handleOnChange = (value, key) => {
    setSave(false)
    // Always clear assessmentTypeError if assessment type changes
    if (key === 'assessmentType' || key === 'assesmentType') {
      setRoundValues({ ...roundValues, [key]: value, assessmentTypeError: '' });
    } else {
      setRoundValues({ ...roundValues, [key]: value, [key + 'Error']: '' });
    }
    if (key == 'roundName') {
      if (
        sortedItems
          ?.map(item => item?.name?.toLowerCase())
          ?.includes(value?.toLowerCase()?.trim())
      ) {
        setDuplicateRoundName(true)
        setRoundValues({
          ...roundValues,
          [key]: value,
          [key + 'Error']: 'Round name already exist.',
        })
      } else {
        setDuplicateRoundName(false)
        setRoundValues({ ...roundValues, [key]: value, [key + 'Error']: '' })
      }
    }
    if (key == 'interviewType') {
      setRoundValues({
        ...roundValues,
        assessmentType: '',
        [key]: value,
        [key + 'Error']: '',
      })
    }

    if (key === 'prePlacement') {
      setRoundValues({
        ...roundValues,
        ...(value === true && {
          type: '',
          assesmentType: '',
          faceToFaceType: '',
        }),

        [key]: value,
      })
    }
  }

  const [saveCall, setSaveCall] = useState({
    saveDetailfirst: false,
    saveDetailSecond: false,
  })

  useEffect(() => {
    if (!save) {
      if (
        roundValues.roundName !== '' ||
        roundValues.interviewType != '' ||
        roundValues.prePlacement ||
        (roundValues.roundDescription !== '' &&
          roundValues.roundDescription !== '<p><br></p>')
      ) {
        setSaveEnable(false)
        setSaveCall({ ...saveCall, saveDetailfirst: false })
      } else if (saveCall.saveDetailSecond) {
        setSaveCall({ ...saveCall, saveDetailfirst: true })
        setSaveEnable(false)
      } else {
        setSaveEnable(true)
      }
    }
  }, [roundValues, save])

  const handleSubmit = async type => {
    setIsSubmitting(true)
    let isValid = true
    let localState = roundValues
    if (!roundValues.roundName) {
      isValid = false
      localState = { ...localState, roundNameError: 'Please Enter round name' }
    }
    if (!roundValues.prePlacement && !roundValues.interviewType) {
      isValid = false
      localState = {
        ...localState,
        interviewTypeError: 'Please Select round type',
      }
    }
    if (!roundValues.prePlacement) {
      if (
        (roundValues.interviewType == 'ASSESMENT' ||
          roundValues.interviewType == 'EXTERNAL_ASSESMENT') &&
        !(roundValues.assesmentType || roundValues.assessmentType)
      ) {
        isValid = false
        localState = {
          ...localState,
          assessmentTypeError:
            roundValues.interviewType == 'ASSESMENT'
              ? 'Please Select assessment type'
              : 'Please select external assessment type',
        }
      } else {
        localState = {
          ...localState,
          assessmentTypeError: '',
        }
      }
      if (
        roundValues.interviewType == 'FACE_TO_FACE' &&
        !roundValues.faceToFaceType
      ) {
        isValid = false
        localState = {
          ...localState,
          faceToFaceTypeError: 'Please Select interview type',
        }
      } else {
        localState = {
          ...localState,
          faceToFaceTypeError: '',
        }
      }
    }
    if (
      !roundValues.roundDescription ||
      roundValues.roundDescription == '<p><br></p>'
    ) {
      isValid = false
      localState = {
        ...localState,
        roundDescriptionError: 'Please enter description',
      }
    }
    if (isValid && !duplicateRoundName) {
      if (isEditingForm) {
        let newData = sortedItems?.map(item =>
          (item?.name === currentId ? true : '')
            ? {
                applied: item.applied,
                name: roundValues.roundName?.trim(),
                type:
                  roundValues.prePlacement === true
                    ? ''
                    : roundValues.interviewType.toUpperCase(),
                assesmentType:
                  roundValues.prePlacement === true
                    ? ''
                    : roundValues.assesmentType
                    ? roundValues.assesmentType.toUpperCase()
                    : roundValues.assessmentType
                    ? roundValues.assessmentType.toUpperCase()
                    : '',
                interviewType: roundValues.interviewType || '',
                description: roundValues.roundDescription,
                faceToFaceType:
                  roundValues.prePlacement === true
                    ? ''
                    : roundValues.faceToFaceType.toUpperCase(),
                id: roundValues.id ?? '',
                prePlacement: roundValues.prePlacement,
              }
            : item
        )
        setSortedItems(newData)
      } else if (sortedItems?.length) {
        setSortedItems(prevSortedItems => {
          return [
            ...prevSortedItems,
            {
              name: roundValues.roundName?.trim(),
              type:
                roundValues.prePlacement === true
                  ? ''
                  : roundValues.interviewType.toUpperCase(),
              assesmentType:
                roundValues.prePlacement === true
                  ? ''
                  : roundValues.assesmentType
                  ? roundValues.assesmentType.toUpperCase()
                  : roundValues.assessmentType
                  ? roundValues.assessmentType.toUpperCase()
                  : '',
              interviewType: roundValues.interviewType || '',
              faceToFaceType:
                roundValues.prePlacement === true
                  ? ''
                  : roundValues.faceToFaceType.toUpperCase(),
              description: roundValues.roundDescription,
              prePlacement: roundValues.prePlacement,
            },
          ]
        })
      } else {
        setSortedItems([
          {
            name: roundValues.roundName?.trim(),
            type:
              roundValues.prePlacement === true
                ? ''
                : roundValues.interviewType.toUpperCase(),
            assesmentType:
              roundValues.prePlacement === true
                ? ''
                : roundValues.assesmentType
                ? roundValues.assesmentType.toUpperCase()
                : roundValues.assessmentType
                ? roundValues.assessmentType.toUpperCase()
                : '',
            interviewType: roundValues.interviewType || '',
            faceToFaceType:
              roundValues.prePlacement === true
                ? ''
                : roundValues.faceToFaceType.toUpperCase(),
            description: roundValues.roundDescription,
            prePlacement: roundValues.prePlacement,
          },
        ])
      }

      setError(isValid)
      if (type === 'save') {
        setScheduleTrue(true)
      }

      clearAll()
      if (type === 'update') {
        setSaveEnable(false)
        setSaveCall({ saveDetailSecond: true, saveDetailfirst: true })
      }
      setIsSubmitting(false)
    } else {
      setSave(false)
      setRoundValues(localState)
      setIsSubmitting(false)
    }
  }

  useEffect(() => {
    if (save && !isSubmitting) {
      if (saveCall.saveDetailfirst) {
        setScheduleTrue(true)
      } else handleSubmit('save')
    }
  }, [save, saveCall, isSubmitting])
  const clearAll = () => {
    setEditText(true)
    setKey(prevKey => prevKey + 1)
    setRoundValues({
      ...roundValues,
      roundName: '',
      roundNameError: '',
      interviewType: '',
      interviewTypeError: '',
      assessmentType: '',
      assessmentTypeError: '',
      roundDescription: '',
      faceToFaceTypeError: '',
      faceToFaceType: '',
      roundDescriptionError: '',
      id: '',
      prePlacement: false,
    })
    handleClear()
    setIsEditingForm(false)
    setCurrentId('')
    setDisableNameField(false)
  }
  useEffect(() => {
    setEditText(false)
  }, [editText])
  const addRound = async () => {
    const { data } = await addNewRound(atsParam)
    if (candidateCall) {
      candidateCall(atsParam)
    }
    setSortedItems(data?.data)
  }
  useEffect(() => {
    setSaveCall({ saveDetailfirst: false, saveDetailSecond: false })
    if (atsParam && openDrawer) addRound()
  }, [atsParam, openDrawer])

  let roundsCount = sortedItems?.length ?? 0

  const sortedItemsWithStudentCount = React.useMemo(() => {
    const metricRounds = rolesMetrics?.rounds || []
    return (sortedItems || []).map(item => {
      const metric = metricRounds.find(m => m?.roundName === item?.name)
      const appliedCount =
        typeof metric?.count === 'number' ? metric.count : item?.applied || 0
      return { ...item, applied: appliedCount }
    })
  }, [sortedItems, rolesMetrics])
  useEffect(() => {
    if (scheduleTrue) {
      setIsSubmitting(true);
      let payload = {
        rounds: sortedItems.map((item, index) => ({
          ...removeEmptyStrings(item),
          name: (item?.name || '').trim(),
          type: (item?.type || '').trim(),
          order: index,
        })),
        forCorporate: true,
      };
      (async () => {
        try {
          // Await the response from updateNewRound
          const response = await updateNewRound(payload, atsParam);
          // Only call getRoleMetrics if updateNewRound was successful
          if (response && response.status === 201) {
            setScheduleTrue(false);
            await getRoleMetrics(params.driveId, params.roleId);
            await addNewRound(params.roleId);
            await fetchRounds();
          }
        } catch (error) {
          console.error('Error updating rounds:', error);
        } finally {
          setScheduleTrue(false);
          setSave(false);
          setIsSubmitting(false);
          if (error === true) {
            setOpenDrawer(false);
          }
        }
      })();
    }
  }, [sortedItems, scheduleTrue]);

  useEffect(() => {
    if (updateRoundData?.message == 'Success') {
      addNewRound(atsParam)
    }
  }, [updateRoundData])

  useEffect(() => {
    setEditText(true)
  }, [openDrawer])

  return (
    <div key={openDrawer}>
      {roundData?.length || sortedItems?.length ? (
        <DragDiv
          headingParam="name"
          descriptionParam="description"
          idParam="id"
          availableItem={roundData?.length ? roundData : []}
          sortedItems={sortedItemsWithStudentCount}
          setSortedItems={setSortedItems}
          onEditClick={handleEditDelete}
          setEditText={setEditText}
          editText={editText}
          disableDelete={false}
          disableEdit={false}
          round="round"
          disabled={false}
        />
      ) : null}

      {(isEditingForm ||
        ((rolesMetrics?.rounds?.length !== 0 &&
          rolesMetrics?.rounds?.[rolesMetrics?.rounds?.length - 1]?.count) ||
          0) === 0) && (
        <>
          {(!singleRoleData?.isInterviewScheduled ||
            isEditingForm ||
            (rolesMetrics?.rounds?.length &&
              rolesMetrics?.rounds[rolesMetrics?.rounds?.length - 1]?.count ===
                0)) && (
            <div style={{ scrollPaddingTop: '300px' }} id="editForm">
              {!isEditingForm && (
                <SecondaryHeading>Round {roundsCount + 1}</SecondaryHeading>
              )}

              <div>
                <div style={{ marginTop: '2em', marginBottom: '1.5em' }}>
                  <Label>Round name *</Label>
                </div>
                <Input
                  type="text"
                  width="100%"
                  placeholder="Add Round Name"
                  value={roundValues?.roundName}
                  onChange={({ target }) =>
                    handleOnChange(target.value, 'roundName')
                  }
                  status={roundValues?.roundNameError && 'error'}
                  disabled={disableNameField}
                />
                <RedText>{roundValues?.roundNameError} </RedText>
              </div>
              {!roundValues?.prePlacement && (
                <div>
                  <div style={{ marginTop: '2em', marginBottom: '1em' }}>
                    <Label>Evaluation type *</Label>
                  </div>
                  <FormItem>
                    <RadioGroup
                      flexFlow="wrap"
                      onChange={({ target }) =>
                        handleOnChange(target.value, 'interviewType')
                      }
                      value={roundValues?.interviewType}
                    >
                      {RadioOptions?.map((item, index) => (
                        <Radio
                          key={index + item?.value}
                          border={true}
                          label={item?.label}
                          value={item?.value}
                          disabled={singleRoleData?.isInterviewScheduled}
                        />
                      ))}
                    </RadioGroup>
                  </FormItem>
                  <RedText>{roundValues?.interviewTypeError}</RedText>
                </div>
              )}
              {!roundValues?.prePlacement && (
                <>
                  {roundValues?.interviewType == 'ASSESMENT' ? (
                    <div>
                      <div style={{ marginTop: '1em', marginBottom: '1em' }}>
                        <Label>Assessment Type *</Label>
                      </div>
                      <FormItem>
                        <RadioGroup
                          spaceBetween
                          onChange={({ target }) =>
                            handleOnChange(target.value, 'assessmentType')
                          }
                          value={roundValues?.assessmentType}
                        >
                          {assessmentOptions?.map((item, index) => (
                            <Radio
                              width={'30%'}
                              key={index + item?.value}
                              border={true}
                              label={item?.label}
                              value={item?.value}
                              disabled={singleRoleData?.isInterviewScheduled}
                            />
                          ))}
                        </RadioGroup>
                      </FormItem>
                      <RedText>{roundValues?.assessmentTypeError}</RedText>
                    </div>
                  ) : roundValues?.interviewType == 'FACE_TO_FACE' ? (
                    <div>
                      <div style={{ marginTop: '1em', marginBottom: '1em' }}>
                        <Label>Type *</Label>
                      </div>
                      <FormItem>
                        <RadioGroup
                          onChange={({ target }) =>
                            handleOnChange(target?.value, 'faceToFaceType')
                          }
                          gap="37px"
                          value={roundValues?.faceToFaceType}
                        >
                          {faceToFaceOptions?.map((item, index) => (
                            <Radio
                              width={'30%'}
                              key={index + item?.value}
                              border={true}
                              label={item?.label}
                              value={item?.value}
                              disabled={singleRoleData?.isInterviewScheduled}
                            />
                          ))}
                        </RadioGroup>
                      </FormItem>
                      <RedText>{roundValues?.faceToFaceTypeError}</RedText>
                    </div>
                  ) : roundValues?.interviewType == 'EXTERNAL_ASSESMENT' ? (
                    <div>
                      <div style={{ marginTop: '1em', marginBottom: '1em' }}>
                        <Label>External Assessment Type *</Label>
                      </div>
                      <FormItem>
                        <RadioGroup
                          onChange={({ target }) =>
                            handleOnChange(target?.value, 'assesmentType')
                          }
                          gap="37px"
                          value={roundValues?.assesmentType}
                        >
                          {externalAssessmentTypes?.map((item, index) => (
                            <Radio
                              width={'30%'}
                              key={index + item?.value}
                              border={true}
                              label={item?.label}
                              value={item?.value}
                              disabled={singleRoleData?.isInterviewScheduled}
                            />
                          ))}
                        </RadioGroup>
                      </FormItem>
                      <RedText>{roundValues?.assessmentTypeError}</RedText>
                    </div>
                  ) : null}
                </>
              )}
              <div>
                <FormItem>
                  <RichEditor
                    key={key + 'roundDescription'}
                    labelName="Round description *"
                    placeholder="E.g.  There is no negative marking."
                    value={roundValues?.roundDescription}
                    onChange={data => handleOnChange(data, 'roundDescription')}
                    editText={editText}
                  />
                </FormItem>
              </div>
              <RedText>{roundValues?.roundDescriptionError}</RedText>
              <div id="section1"></div>
              {isEditingForm ? (
                <FlexWrap gap="20px">
                  <Button.Secondary
                    text={'Cancel'}
                    width="100%"
                    onClick={() => handleEditDelete('', 'cancel')}
                    disabled={isSubmitting}
                  />
                  <Button.Secondary
                    text={'Update Round'}
                    width="100%"
                    dashed="true"
                    loading={isSubmitting}
                    onClick={() => handleSubmit('update')}
                  />
                </FlexWrap>
              ) : (
                <Button.Secondary
                  text={'Add Rounds'}
                  width="100%"
                  icon={<PlusIcon color="#3249D7" />}
                  dashed="true"
                  loading={isSubmitting}
                  disable={
                    rolesMetrics?.rounds?.length &&
                    rolesMetrics?.rounds[rolesMetrics?.rounds?.length - 1]
                      ?.count > 0
                  }
                  onClick={() => handleSubmit('update')}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default EvaluationForm

function removeEmptyStrings(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== '')
  );
}
